<template>
  <v-tab-item value="contact">
    <div class="page">


  <div class="page-header">
    <!-- <div class="eyebrow">// Contact</div> -->
    <h1>Get in touch with<br>YazamTech.</h1>
  </div>

  <div class="contact-rows">

    <div class="contact-row">
      <span class="row-label">Email</span>
      <span class="row-value" style="font-weight: 500; font-family: var(--mono);">info&#64;yazamtech.com</span>

    </div>

    <div class="contact-row">
      <span class="row-label">Phone</span>
      <div class="phone-pair">
        <div class="phone-item">
          <div class="phone-region">EMEA</div>
          <div class="phone-num">+972.9.743.5965</div>
        </div>
        <div class="phone-item">
          <div class="phone-region">US</div>
          <div class="phone-num">+1.949.284.1136</div>
        </div>
      </div>
    </div>

    <div class="contact-row">
      <span class="row-label">Website</span>
      <span class="row-value">
        <a href="https://www.YazamTech.com" target="_blank">www.YazamTech.com</a>
      </span>
    </div>

    <div class="contact-row">
      <span class="row-label">LinkedIn</span>
      <a href="https://www.linkedin.com/company/yazamtech-ltd./" target="_blank" class="linkedin-btn">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
        Connect on LinkedIn
      </a>
    </div>

  </div>

  
  <!-- LIBRARYS USAGE -->
  <div class="mb-3 mx-2">
    <div class="stack-label">Yazam MFT built with</div>
    <div class="tags">
          <a v-for="(pac, i) in packagesUsage" :key="pac.name" class="tag" :href="pac.url">{{ pac.name }}</a>

          <!-- <a
          v-for="(pac, i) in packagesUsage"
          :key="pac.name"
          :href="pac.url"
          class="mx-1"
          :class="[i === packagesUsage.length - 1 ? 'dot' : 'colon']"
          target="_blank"
          >{{ pac.name }}</a
          > -->
        </div>
      </div>
    </div>
  </v-tab-item>
</template>

<script>
import { packagesUsage } from './Contact'

export default {
  name: 'Contact',
  data() {
    return {
      packagesUsage,
    }
  },
}
</script>

<style scoped>
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }



body {
  font-family: var(--sans);
  background: var(--bg);
  color: var(--ink);
  min-height: 100vh;
}

/* NAV */
nav {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--border);
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 100;
  padding: 0 3rem;
}

.nav-logo {
  font-family: var(--mono);
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--accent);
  margin-right: 3rem;
  padding: 1.1rem 0;
}

nav a {
  text-decoration: none;
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: var(--muted);
  padding: 1.3rem 1.3rem;
  transition: color 0.2s;
  position: relative;
}

nav a:hover { color: var(--ink); }
nav a.active { color: var(--accent); }
nav a.active::after {
  content: '';
  position: absolute;
  bottom: -1px; left: 0; right: 0;
  height: 2px;
  background: var(--accent);
}

/* PAGE */
.page {
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem 3rem 2rem;

}

/* HEADER */
.page-header {
  margin-bottom: 2rem;
}

.eyebrow {
  font-family: var(--mono);
  font-size: 0.68rem;
  color: var(--accent);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  margin-bottom: 1rem;
}

h1 {
  font-size: 3rem;
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1.1;
  color: var(--ink);
}

h1 em {
  font-style: normal;
  color: var(--accent);
}

.subtitle {
  margin-top: 0.75rem;
  font-size: 0.95rem;
  color: var(--muted);
  font-weight: 300;
}

/* CONTACT ROWS */
.contact-rows {
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--border);
  margin-bottom: 4rem;
}

.contact-row {
  display: flex;
  align-items: center;
  padding: 1.8rem 0;
  border-bottom: 1px solid var(--border);
  gap: 3rem;
  transition: background 0.15s;
}



.row-label {
  font-family: var(--mono);
  font-size: 13px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--muted);
  min-width: 100px;
  flex-shrink: 0;
}

.row-value {
  font-size: 18px;
  color: var(--ink);
  font-weight: 400;
}

.row-value a {
  color: var(--accent);
  text-decoration: none;
  font-weight: 500;
  transition: opacity 0.15s;
}

.row-value a:hover { opacity: 0.75; }

.row-value.mono {
  font-family: var(--mono);
  font-size: 0.95rem;
}

/* Phone row - two numbers side by side */
.phone-pair {
  display: flex;
  gap: 4rem;
}

.phone-item {}

.phone-region {
  font-family: var(--mono);
  font-size: 12px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--muted);
  margin-bottom: 0.2rem;
}

.phone-num {
  font-family: var(--mono);
  font-size: 18px;
  color: var(--ink);
}

/* LinkedIn button */
.linkedin-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  background: var(--accent);
  color: #fff;
  text-decoration: none;
  padding: 0.7rem 1.3rem;
  font-size: 0.78rem;
  font-weight: 500;
  letter-spacing: 0.04em;
  transition: all 0.2s;
}

.linkedin-btn:hover {
  background: #0041cc;
  box-shadow: 0 4px 14px rgba(0,87,255,0.22);
}

/* STATUS */
.status-badge {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--mono);
  font-size: 0.65rem;
  color: var(--muted);
}

.status-dot {
  width: 6px; height: 6px;
  background: #22c55e;
  border-radius: 50%;
  animation: blink 2s ease-in-out infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

/* STACK */
.stack-label {
  font-family: var(--mono);
  font-size: 13px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--muted);
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.stack-label::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--border);
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.tag {
  font-family: var(--mono);
  font-size: 11px;
  padding: 0.28rem 0.75rem;
  border: 1px solid var(--border);
  color: var(--muted);
  background: #fff;
  transition: all 0.15s;
  cursor: default;
}

.tag:hover {
  border-color: var(--accent);
  color: var(--accent);
}

/* Animations */
@keyframes fadeUp {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

.page-header    { animation: fadeUp 0.4s ease both; }
.contact-rows   { animation: fadeUp 0.4s 0.08s ease both; }
.stack-label,
.tags           { animation: fadeUp 0.4s 0.18s ease both; }

@media (max-width: 640px) {
  .page { padding: 3rem 1.5rem 4rem; }
  h1 { font-size: 2rem; }
  .phone-pair { flex-direction: column; gap: 1rem; }
  nav { padding: 0 1.5rem; }
  .contact-row:hover { margin: 0; padding-left: 0; padding-right: 0; }
}
</style>
